import rebateReceiptElectronicTypeItemMachine from './rebateReceiptElectronicTypeItemMachine';

export * from './rebateReceiptElectronicTypeItemMachine';
export default rebateReceiptElectronicTypeItemMachine;
